<div class="adaa-ribbon">
    @if (showLogo()) {
        <div class="adaa-ribbon__logo">
            <ng-content select="[ribbonLogo]"></ng-content>
        </div>
    }

    <div class="adaa-ribbon__grid">
        <div class="adaa-ribbon__cells" [style.--adaa-ribbon-cell-min]="cellMin()">
            @for (widget of widgetData(); track $index) {
                @if (widget.isDuo) {
                    <div class="adaa-ribbon__cell adaa-ribbon__cell--duo">
                        @for (item of widget.items; track $index) {
                            <div class="adaa-ribbon__duo-row">
                                <span class="adaa-ribbon__label text-truncate {{ item.labelClasses }}">{{ item.label | translate }}</span>
                                <span class="adaa-ribbon__value {{ item.dataClasses }}">{{ item.data }}</span>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="adaa-ribbon__cell">
                        @if (widget.icon) {
                            <span class="adaa-ribbon__icon">
                                <i class="{{ widget.icon }}"></i>
                            </span>
                        }

                        <span class="adaa-ribbon__body">
                            <span class="adaa-ribbon__label {{ widget.labelClasses }}">{{ widget.label | translate }}</span>
                            <span class="adaa-ribbon__figure">
                                <span class="adaa-ribbon__value {{ widget.dataClasses }}">{{ widget.data }}</span>
                                @if (widget.symbol) {
                                    <span class="adaa-ribbon__symbol">{{ widget.symbol }}</span>
                                }
                            </span>
                        </span>
                    </div>
                }
            }
            <div class="adaa-ribbon__extras">
                <ng-content select="[progressBars]"></ng-content>
            </div>
        </div>
    </div>

    @if (showRefreshIcon() || showFilterIcon()) {
        <div class="adaa-ribbon__actions">
            @if (showRefreshIcon()) {
                <button type="button" class="btn btn-sm adaa-ribbon__action" (click)="refreshClicked.emit()">
                    <fa-icon [icon]="refreshIcon" />
                </button>
            }
            @if (showFilterIcon()) {
                <button
                    type="button"
                    class="btn btn-sm adaa-ribbon__action adaa-ribbon__action--filter"
                    [class.btn-light]="!filterApplied()"
                    [class.btn-primary]="filterApplied()"
                    [class.is-applied]="filterApplied()"
                    (click)="filterClicked.emit()"
                >
                    <fa-icon [icon]="filterIcon" />
                </button>
            }
        </div>
    }
</div>
